import { ChatMessageKind } from '../angular-contracts';

export interface Message {
    text: string;
    fromAi: boolean;
    /** True when the message is from a human agent (support), not the AI. */
    fromHuman?: boolean;
    /** Display name of the human agent who sent the message (widget/dashboard). */
    senderName?: string;
    /** Centered system row: human agent joined / handed back to AI. */
    kind?: ChatMessageKind;
    /** Agent display name for human_joined banner. */
    joinAgentName?: string;
    /** Profile photo URL for human_joined / human messages when available. */
    joinAgentImageUrl?: string;
    senderImageUrl?: string;
    /** Second line: spectator joined vs active chat. */
    joinWatchingOnly?: boolean;
    /** human_left row: who left (if known). */
    leftAgentName?: string;
    /** Unix ms when shown — for "Name • Role • 2m ago" footer. */
    sentAt?: number;
    /** AI message still receiving lk.transcription stream chunks */
    streaming?: boolean;
    /** Visitor file upload (human handoff): render as image or link instead of plain URL text. */
    attachment?: { url: string; fileName: string; isImage: boolean };
    /** Visitor voice recording: render as audio player; text field holds the STT transcription. */
    voiceAttachment?: { url: string; blobUrl?: string; durationSec?: number };
}

export enum chatWidgetType {
    ChatWidgetAudio = 'ChatWidgetAudio',
    ChatWidgetText= 'ChatWidgetText',
}